export const LANGUAGES = [
  { value: 'af', label: 'Afrikaans' },
  { value: 'sq', label: 'Albanees' },
  { value: 'am', label: 'Amhaars' },
  { value: 'ar', label: 'Arabisch' },
  { value: 'hy', label: 'Armeens' },
  { value: 'az', label: 'Azerbeidzjaans' },
  { value: 'eu', label: 'Baskisch' },
  { value: 'be', label: 'Wit-Russisch' },
  { value: 'bn', label: 'Bengaals' },
  { value: 'bs', label: 'Bosnisch' },
  { value: 'bg', label: 'Bulgaars' },
  { value: 'ca', label: 'Catalaans' },
  { value: 'zh', label: 'Chinees' },
  { value: 'hr', label: 'Kroatisch' },
  { value: 'cs', label: 'Tsjechisch' },
  { value: 'da', label: 'Deens' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'en', label: 'Engels' },
  { value: 'et', label: 'Estisch' },
  { value: 'fi', label: 'Fins' },
  { value: 'fr', label: 'Frans' },
  { value: 'gl', label: 'Galicisch' },
  { value: 'ka', label: 'Georgisch' },
  { value: 'de', label: 'Duits' },
  { value: 'el', label: 'Grieks' },
  { value: 'gu', label: 'Gujarati' },
  { value: 'he', label: 'Hebreeuws' },
  { value: 'hi', label: 'Hindi' },
  { value: 'hu', label: 'Hongaars' },
  { value: 'is', label: 'IJslands' },
  { value: 'id', label: 'Indonesisch' },
  { value: 'ga', label: 'Iers' },
  { value: 'it', label: 'Italiaans' },
  { value: 'ja', label: 'Japans' },
  { value: 'kn', label: 'Kannada' },
  { value: 'kk', label: 'Kazachs' },
  { value: 'km', label: 'Khmer' },
  { value: 'ko', label: 'Koreaans' },
  { value: 'ky', label: 'Kirgizisch' },
  { value: 'lo', label: 'Laotiaans' },
  { value: 'lv', label: 'Lets' },
  { value: 'lt', label: 'Litouws' },
  { value: 'mk', label: 'Macedonisch' },
  { value: 'ms', label: 'Maleis' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'mt', label: 'Maltees' },
  { value: 'mr', label: 'Marathi' },
  { value: 'mn', label: 'Mongools' },
  { value: 'ne', label: 'Nepalees' },
  { value: 'no', label: 'Noors' },
  { value: 'fa', label: 'Perzisch' },
  { value: 'pl', label: 'Pools' },
  { value: 'pt', label: 'Portugees' },
  { value: 'pa', label: 'Punjabi' },
  { value: 'ro', label: 'Roemeens' },
  { value: 'ru', label: 'Russisch' },
  { value: 'sr', label: 'Servisch' },
  { value: 'sk', label: 'Slowaaks' },
  { value: 'sl', label: 'Sloveens' },
  { value: 'es', label: 'Spaans' },
  { value: 'sw', label: 'Swahili' },
  { value: 'sv', label: 'Zweeds' },
  { value: 'ta', label: 'Tamil' },
  { value: 'te', label: 'Telugu' },
  { value: 'th', label: 'Thais' },
  { value: 'tr', label: 'Turks' },
  { value: 'uk', label: 'Oekraïens' },
  { value: 'ur', label: 'Urdu' },
  { value: 'uz', label: 'Oezbeeks' },
  { value: 'vi', label: 'Vietnamees' },
  { value: 'cy', label: 'Welsh' },
  { value: 'xh', label: 'Xhosa' },
  { value: 'yi', label: 'Jiddisch' },
  { value: 'zu', label: 'Zoeloe' }
];
